import { render, staticRenderFns } from "./floatItem.vue?vue&type=template&id=2514d524&scoped=true"
import script from "./floatItem.vue?vue&type=script&lang=js"
export * from "./floatItem.vue?vue&type=script&lang=js"
import style0 from "./floatItem.vue?vue&type=style&index=0&id=2514d524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514d524",
  null
  
)

export default component.exports